<pre class="bg-slate-300 text-slate-700 px-14 py-5 w-fit h-fit shadow-md rounded-md text-lg {$$props.class}">
<slot />
</pre>
